<template>
  <div v-if="ir !== null">
    <!-- Page Title -->
    <h3>Page Title</h3>
    <div class="py-5">顯示於Investor Relations頁面</div>
    <div>
      <!-- Title -->
      <div class="form-item py-5 d-flex">
        <div class="w-174px mr-6">
          <h4>Title</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          {{ ir.page_title }}
        </div>
      </div>
      <!-- Banner -->
      <div class="form-item py-5 d-flex">
        <div class="w-174px mr-6">
          <h4>Banner</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <div
            class="w-305px h-187px bg-cover bg-center ml-auto"
            :style="{
              'background-image': `url(${ir.page_banner||defaultBanner})`,
              'border-radius': '8px',
            }"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    ir: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    defaultBanner: 'https://dummyimage.com/305x187.jpg',
  }),
};
</script>

<style></style>
